// Utility Functions

export const fetchJSON = async (url, options = {}) => {
    try {
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          ...(options.headers || {}),
        },
        ...options,
      });
  
      if (!response.ok) {
        const errorText = `HTTP ${response.status}: ${response.statusText}`;
        throw new Error('Network response was not ok: ' + errorText);
      }
  
      if (response.status === 204) {
        return null;
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Fetch error at ${url}:`, error);
      throw error;
    }
};
  
export const buildURL = (baseURL, params = {}) => {
    const url = new URL(baseURL);
    Object.keys(params).forEach((key) => {
        url.searchParams.append(key, params[key]);
    });
    return url.toString();
};

export const postImage = async (url, file, extraFields = {}) => {
  const formData = new FormData();
  formData.append('file', file);

  // Append any extra fields if needed (e.g., altText, pw, etc.)
  Object.entries(extraFields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`Upload failed: HTTP ${response.status} ${response.statusText}`);
  }

  return response.json();
};
